import { createGlobalStyle } from "styled-components"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fab } from "@fortawesome/free-brands-svg-icons"
import {
  faEnvelope,
  faPaperclip,
  faExternalLinkAlt,
  faFire,
  faCross,
} from "@fortawesome/free-solid-svg-icons"

library.add(fab, faEnvelope, faPaperclip, faExternalLinkAlt, faFire, faCross)

const GlobalStyle = createGlobalStyle`
 
  @font-face {
    font-family: "JetBrains Mono Regular";
    src: url("https://raw.githubusercontent.com/JetBrains/JetBrainsMono/master/web/woff/JetBrainsMono-Regular.woff")
  }
  @font-face {
    font-family: "JetBrains Mono Medium";
    src: url("https://raw.githubusercontent.com/JetBrains/JetBrainsMono/master/web/woff/JetBrainsMono-Medium.woff")
  }
  @font-face {
    font-family: "JetBrains Mono Bold";
    src: url("https://raw.githubusercontent.com/JetBrains/JetBrainsMono/master/web/woff/JetBrainsMono-Bold.woff")
  }
  @font-face {
    font-family: "JetBrains Mono ExtraBold";
    src: url("https://raw.githubusercontent.com/JetBrains/JetBrainsMono/master/web/woff/JetBrainsMono-ExtraBold.woff")
  }
  @font-face {
    font-family: 'Sriracha';
    font-style: normal;
    font-weight: 400;
    src: local('Sriracha'), local('Sriracha-Regular'), url(https://fonts.gstatic.com/s/sriracha/v4/0nkrC9D4IuYBgWcI9NbLTwHSoQ.woff2) format('woff2');
    unicode-range: U+0E01-0E5B, U+200C-200D, U+25CC;
  }
  @font-face {
    font-family: 'Sriracha';
    font-style: normal;
    font-weight: 400;
    src: local('Sriracha'), local('Sriracha-Regular'), url(https://fonts.gstatic.com/s/sriracha/v4/0nkrC9D4IuYBgWcI9NbQTwHSoQ.woff2) format('woff2');
    unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;
  }
  @font-face {
    font-family: 'Sriracha';
    font-style: normal;
    font-weight: 400;
    src: local('Sriracha'), local('Sriracha-Regular'), url(https://fonts.gstatic.com/s/sriracha/v4/0nkrC9D4IuYBgWcI9NbRTwHSoQ.woff2) format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  @font-face {
    font-family: 'Sriracha';
    font-style: normal;
    font-weight: 400;
    src: local('Sriracha'), local('Sriracha-Regular'), url(https://fonts.gstatic.com/s/sriracha/v4/0nkrC9D4IuYBgWcI9NbfTwE.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Special Elite';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/specialelite/v10/XLYgIZbkc4JPUL5CVArUVL0ntnAOSA.woff2);
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Noto Sans HK';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: local('Noto Sans HK Regular'), local('NotoSansHK-Regular'), url(https://fonts.gstatic.com/s/notosanshk/v5/nKKQ-GM_FYFRJvXzVXaAPe9hMRhvEPeWV8Ydw9dTvaja5emiwCL1Dv89rTx5gtGuOA.1.woff2) format('woff2');
    unicode-range: U+28189, U+281af, U+281bc, U+28207, U+28218, U+2821a, U+28256, U+2827c, U+2829b, U+282cd, U+282e2, U+28306, U+28318, U+2832f, U+2833a, U+28365, U+2836d, U+2837d, U+2838a, U+28412, U+28468, U+2846c, U+28473, U+28482, U+28501, U+2853c-2853d, U+2856c, U+285e8, U+285f4, U+28600, U+2860b, U+28625, U+2863b, U+286aa-286ab, U+286b2, U+286bc, U+286d8, U+286e6, U+2870f, U+28713, U+28804, U+2882b, U+2890d, U+28933, U+28948-28949, U+28956, U+28964, U+28968, U+2896c-2896d, U+2897e, U+28989, U+2898d, U+289a8, U+289aa-289ab, U+289b8, U+289bc, U+289c0, U+289dc, U+289de, U+289e1, U+289e3-289e4, U+289e7-289e8, U+289f9-289fc, U+28a0f, U+28a16, U+28a25, U+28a29, U+28a32, U+28a36, U+28a44-28a4b, U+28a59-28a5a, U+28a81-28a83, U+28a9a-28a9c, U+28ac0, U+28ac6, U+28acb-28acc, U+28ace, U+28ade-28ae3, U+28ae5, U+28aea, U+28afc, U+28b0c, U+28b13, U+28b21-28b22, U+28b2b-28b2d, U+28b2f, U+28b46, U+28b4c, U+28b4e, U+28b50, U+28b63-28b66, U+28b6c, U+28b8f, U+28b99, U+28b9c-28b9d, U+28bb9, U+28bc2, U+28bc5, U+28bd4, U+28bd7, U+28bd9-28bda, U+28be7-28bec, U+28bf5, U+28bff, U+28c03, U+28c09, U+28c1c-28c1d, U+28c23, U+28c26, U+28c2b, U+28c30, U+28c39, U+28c3b, U+28cca, U+28ccd, U+28cd2, U+28d34, U+28d99, U+28db9, U+28e0f, U+28e36, U+28e39, U+28e65-28e66, U+28e97, U+28eac;
  }
  @font-face {
    font-family: 'Comfortaa';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(https://fonts.gstatic.com/s/comfortaa/v29/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4Y_LDrMfIA.woff2) format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
  }
  @font-face {
    font-family: 'Comfortaa Reg';
    font-style: normal;
    font-weight: 300;
    src: url(https://fonts.gstatic.com/s/comfortaa/v29/1Pt_g8LJRfWJmhDAuUsSQamb1W0lwk4S4TbMDr4fIA9c.woff2) format('woff2');
    unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
  }

  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    font-feature-settings: "liga" on, "calt" on;
    -webkit-font-feature-settings: "liga" on, "calt" on;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    font-family: 'JetBrains Mono Regular';
  }

  ::selection {
    background:  transparent;
    color:  #f05637;
  }

  html {
    overflow-x: hidden;
  }

  body {
    margin: 0;
    overflow-x: hidden;
    color: white;
    background: #1a1a1a;
  }

  body::-webkit-scrollbar {
    width: 0.5em;
  }

  body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  }

  body::-webkit-scrollbar-thumb {
    background: #333;
    outline: 1px solid white;
    border-radius: 4px;

    &:hover {
      background: #02D463;
    }
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  h1 {
    font-size: 64px;
    font-family: 'JetBrains Mono Bold'
  }

  h2 {
    font-size: 40px;
    font-family: 'Comfortaa'
  }

  h1, h2 {
    text-shadow: 0px 0px 10px black;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    &--primary {
      width: 90%;
    }

    &--secondary {
      width: 90%;
    }
  }

  .default-link {
    &__link {
      margin: 0 10px;
      display: inline-flex;
      overflow: hidden;
      position: relative;
      transition: 0.5s ease;

      &:hover {
        color: #f05637;
        transition: 0.5s ease;
      }

      &:before {
        left: 0;
        bottom: 0;
        width: 100%;
        height: 1px;
        background: #f05637;
        transform: translateX(-100%);
      }

      &:before,
      &:after {
        content: "";
        position: absolute;
        transition: transform 0.5s ease;
      }

      &:hover:before {
        transform: translateX(0);
      }

      &:after {
        content: "";
        position: absolute;
        transition: transform 0.5s ease;
      }
    }
  }

  .btn {
    padding: 10px 17.5px;
    border-radius: 4px;
    border: 2px solid transparent;
    transition: .2s ease;
    margin-right: 20px;
    box-shadow: 0px 0px 20px rgba(0,0,0,0.5);
    outline: none;
    -webkit-appearance: none;
    
    &:hover {
      transition: .2s ease;
    }

    &--primary {
      color: white;
      background: #f05637;

      &:hover {
        background: transparent;
        color: #f05637;
        border: 2px solid  #f05637;
      }
    }

    &--secondary {
      color: #f05637;
      border: 2px solid #f05637;

      &:hover {
        background: #f05637;
        color: white;
        border: 2px solid #f05637;
      }
    }
  }

  .colored {
    color: #f05637 !important;
  }

  .section__desc {
    text-shadow: 0px 0px 10px black;
  }

  .scrolled {
    position: fixed;
    transition: .4s;
    z-index: 5;
    background: #1a1a1a;
    box-shadow: 0px 0px 20px rgba(0,0,0,.5);
    height: 60px;
  }

  /* SIDENAV */

  .hamburger {
    display: none;
    position: relative;
    cursor: pointer;
    z-index: 4;
    outline: none;
    background: none;
    border: none;
  }

  .hamburger__wrapper {
    width: 25px;
    height: 20px;
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    &:hover {
      .hamburger--line {
        background-color:  #f05637;
      }
    }
  }

  .hamburger--line {
    position: absolute;
    height: 3px;
    width: 100%;
    transition: all cubic-bezier(0.26, 0.1, 0.27, 1.55) 0.35s;
    background-color: #fff;
  }

  .top {
    top: 0%;
    width: 75%;
    left: 0%;
  }

  .middle {
    top: 45%;
    width: 75%;
  }

  .bottom {
    top: 90%;
    width: 75%;
    left: 0%;
  }

  .icon.close .top {
    transform: rotate(45deg);
    top: 48%;
    width: 100%;
  }

  .icon.close .middle,
  .icon.close .bottom {
    transform: rotate(-45deg);
    top: 48%;
    width: 100%;
  }

  .sidenav--open {
    width: 40% !important;
    transition: 0.5s;
  }

  .sidenav {
    width: 0px;
    height: 100%;
    position: fixed;
    top: 0px;
	  right: 0px;
    z-index: 3;
    background-color: #111;
    transition: 0.2s ease-in-out;
    overflow: hidden;
    box-shadow: 0px 0px 10px rgba(0,0,0,.5);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    a {
      margin: 30px 0;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;
      display: block;
      transition: 0.2s ease-in-out;
      color: inherit;

      :hover:not(.navbar__resume) {
        color: #f05637;
      }

      &.navbar__resume {
        margin-left: 0;
        color: #f05637;

        &:hover {
          color: #fff;
        }
      }
    }

    .active {
      width: 100%;
      height: fit-content;
      font-weight: 500;
      color: #49a9e0;
    }

    &__more {
      transform: translateX(1rem);
      
      a {
        font-size: 14px;
      }
    }
  }

  .sidenav__content {
    position: relative;
    width: fit-content !important;
  }

  /* SIDENAV END */

  @media screen and (max-width: 1280px) {
    .board__container {
      width: 758px;
      height: 450px;
      bottom: -200px;
      right: -100px;
    }
  }

  @media screen and (max-width: 1080px) {
    .board__container {
      width: 506px;
      height: 300px;
      bottom: -50px;
      padding: 10px;
    }
  }

  @media screen and (max-width: 768px) {
    body {
      font-size: 14px;
    }
    h1 {
      font-size: 48px;
    }
    h2 {
      font-size: 18px;
    }
    h3 {
      font-size: 20px !important;
    }
    footer {
      height: 120px !important;
    }
    #home {
      background-attachment: scroll;
    }
    .hamburger {
		  display: block;
	  }
    .navbar__links {
      display: none;
    }
    .board__container {
      display: none;
    }

    .decoration__tick {
      left: 65% !important;
    }

    .container__hero--secondary {
      margin: 2rem 0 !important;
    }

    .about__container {
      flex-direction: column !important;
      img {
        align-self: flex-start !important;
        margin-bottom: 50px;
        width: 100% !important;
      }
    }

    .about__wrapper {
      width: 100%;
    }

    .about__desc, .hero__desc {
      width: 100% !important;
    }

    .work__wrapper {
      grid-template-columns: repeat(1, 1fr) !important;
    }

    .work--animation {
      margin: 0 !important;
    }

    .input__field--grid, .input__textarea {
      width: 100% !important;
    }

    .input__field--grid {
      grid-template-columns: repeat(1,1fr) !important;
    }

    .footer__container {
      flex-direction: column;
    }

    .footer__desc {
      text-align: center;
    }

    .footer__copy {
      margin-top: 25px;
    }

    .footer__link {
      margin: 0 20px !important;
    }
  }

  @media screen and (max-width: 400px) {
    .footer__links {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }

    .footer__link {
      margin: 0 !important;
    }
  }
`

export default GlobalStyle
